module.exports = __webpack_public_path__ + "static/media/loading-spinner.302a2f02.svg";